var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncheckedRound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.903 0c6.507 0 11.801 5.384 11.801 12s-5.294 12-11.8 12C5.396 24 .101 18.616.101 12S5.397 0 11.903 0zm5.514 6.387a.992.992 0 0 0-1.402-.012l-4.161 4.16-4.16-4.16-.086-.076a.994.994 0 0 0-1.317.088.992.992 0 0 0-.012 1.402l4.16 4.16-4.16 4.161-.076.086a.994.994 0 0 0 .088 1.317.992.992 0 0 0 1.402.012l4.16-4.161 4.162 4.16.085.077a.994.994 0 0 0 1.317-.088.992.992 0 0 0 .012-1.403l-4.161-4.161 4.16-4.16.077-.086a.994.994 0 0 0-.088-1.316z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckedRound);
export default __webpack_public_path__ + "static/media/unchecked-round.a5cf6fe33afc0ee4c2a72059efb8dcdf.svg";
export { ForwardRef as ReactComponent };